import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";
import DatatableFunc from "../../../Common/DatatableFunc";

const List = () => {
  const [depositForms, setDepositForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({});

  useEffect(() => {
    DatatableFunc();
    fetchDepositForms();
  }, []);

  const fetchDepositForms = async () => {
    try {
      setLoading(true);
      const response = await Http.get("/accounts/deposit-forms");
      // Extract the data array from the response structure
      console.log((response.data.data))
      setDepositForms(response.data.data);
    } catch (error) {
      console.error("Error fetching deposit forms:", error);
      setError({ general: "Failed to load deposit forms" });
    } finally {
      setLoading(false);
    }
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "Not set";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const cols = [
    { 
      header: "Date",
      field: (rowData) => formatDate(rowData.date)
    },
    { field: "shift", header: "Shift" },
    // { field: "total_amount", header: "Total Amount" },
    { field: "grand_total_amount", header: "Grand Total" },
  ];

  const actionTemplate = (item) => {
    return (
      <td className="text-xs text-center">
        <Link
          to={`/view-daily-collection/${item.id}`}
          className="btn btn-info btn-sm ms-1"
          title="View Deposit Form"
        >
          <i className="fa fa-list" aria-hidden="true"></i>
        </Link>
        <Link
          to={`/edit-daily-collection/${item.id}`}
          className="btn btn-primary btn-sm ml-1"
          title="Edit"
        >
          <i className="fa fa-pencil" aria-hidden="true"></i>
        </Link>
      </td>
    );
  };

  return (
    <div>
      <IsLogin />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Daily Collection</h5>
          <div className="am-pagetitle-right">
            <Link to="/create-daily-collection" className="btn btn-primary">
              <i className="fa fa-plus"></i> Create Daily Collection
            </Link>
          </div>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
              {error.general && (
                <div className="alert alert-danger">{error.general}</div>
              )}
              
              <ReactDataTable
                cols={cols}
                receiveData={depositForms}
                isLoading={loading}
                actionTemplate={actionTemplate}
              />
            </div>
        </div>
      </div>
    </div>
  );
};

export default List;